export default __webpack_public_path__ + "static/media/Heby_full.a984fbff.png";